import * as React from 'react';

function PostArchives(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={13} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.875 11.063c0 .738.574 1.312 1.313 1.312h9.624c.711 0 1.313-.574 1.313-1.313V3.625H.875v7.438zm3.5-5.36c0-.164.137-.328.328-.328h4.594c.164 0 .328.164.328.328v.219a.332.332 0 01-.328.328H4.703a.316.316 0 01-.328-.328v-.219zm8.75-5.578H.875A.881.881 0 000 1v1.313c0 .246.191.437.438.437h13.124A.45.45 0 0014 2.312V1a.9.9 0 00-.875-.875z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default PostArchives;
